<button type="button" class="rotation" (click)="togglePlayPause()" *ngIf="isCarouselInited"
[title]="isCarouselAutoPlaying ? ('pauseAutoCarousel' | translate) : ('resumeAutoCarousel' | translate)">
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" class="icon-play" aria-hidden="true" *ngIf="!isCarouselAutoPlaying">
    <!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.-->
    <path fill="#fff" d="M73 39c-14.8-9.1-33.4-9.4-48.5-.9S0 62.6 0 80L0 432c0 17.4 9.4 33.4 24.5 41.9s33.7 8.1 48.5-.9L361 297c14.3-8.7 23-24.2 23-41s-8.7-32.2-23-41L73 39z"/>
  </svg>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" class="icon-pause" aria-hidden="true" *ngIf="isCarouselAutoPlaying">
    <!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.-->
    <path fill="#fff" d="M48 64C21.5 64 0 85.5 0 112L0 400c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-288c0-26.5-21.5-48-48-48L48 64zm192 0c-26.5 0-48 21.5-48 48l0 288c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-288c0-26.5-21.5-48-48-48l-32 0z"/>
  </svg>
  <span class="visually-hidden">{{isCarouselAutoPlaying ? ('pauseAutoCarousel' | translate) : ('resumeAutoCarousel' | translate)}}</span>
</button>

<div id="banner_Carousel" class="carousel slide position-relative" data-bs-ride="carousel" data-bs-pause="false" data-bs-ride="carousel" tabindex="-1">
  <a *ngIf="nav && bannerMeta && bannerMeta.length > 1" class="left carousel-control" href="#banner_Carousel" data-bs-slide="prev" title="{{'preImage' | translate}}">
    <span class="fa fa-chevron-left fa-lg" title="{{'preImage' | translate}}" aria-hidden="true"></span>
    <span class="sr-only visually-hidden">{{'preImage' | translate}}</span>
  </a>
  
  <div class="carousel-inner rounded-4">
    <div *ngFor="let data of bannerMeta;let i = index"
    id="banner_Carousel_slide_{{i}}"
    class="carousel-item"
    role="tabpanel"
    [class.link-item]="data.link"
    [class.active]="i == activeSlideIndex"
    [class.video-item]="data.videoUrl">
      <ng-container *ngIf="data.imageFile">
        <a *ngIf="data.link" href="{{data.link}}" target="_blank" title="{{data.title}}[{{'openNewWindow' | translate}}]">
          <picture>
            <source attr.srcset="{{data.imageMobileFile.url}}" media="(max-width: 768px)" *ngIf="data.imageMobileFile"/>
            <img src="{{data.imageFile.url}}" alt="{{data.title}}" class="focusable-box fit_cover" tmObjectFit="cover" imgSrc="{{data.imageFile.url}}" (load)="onMediaSrcLoad(i)"/>
          </picture>
        </a>
        <ng-container *ngIf="!data.link">
          <picture>
            <source attr.srcset="{{data.imageMobileFile.url}}" media="(max-width: 768px)" *ngIf="data.imageMobileFile"/>
            <img src="{{data.imageFile.url}}" alt="{{data.title}}" title="{{data.title}}"
            width="1920" height="1500" [attr.loading]="i == 0 ? 'eager' : 'lazy'"
            (load)="onMediaSrcLoad(i)"/>
          </picture>
        </ng-container>
      </ng-container>
      <div style="max-height: 100vh;" *ngIf="data.videoUrl">
        <ng-container *ngIf="data.link; else videoBannerTemp">
          <ng-container *ngTemplateOutlet="videoBannerTemp"></ng-container>
          <a href="{{data.link}}" target="_blank" title="{{'openNewWindow' | translate}}"></a>
        </ng-container>
        <ng-template #videoBannerTemp>
          <video width="100%" height="auto" muted="true" loop="" *ngIf="!isTouchScreen">
            <source [src]="$any(data.videoUrl | safe: 'resource')" type="video/mp4">
            <source [src]="$any(data.videoUrl | safe: 'resource')" type="video/ogg">
          </video>
          <video width="100%" height="auto" muted="true" loop="" playsinline="" *ngIf="isTouchScreen">
            <source [src]="$any(data.videoUrl | safe: 'resource')" type="video/mp4">
            <source [src]="$any(data.videoUrl | safe: 'resource')" type="video/ogg">
          </video>
        </ng-template>
      </div>
      <ng-container *ngIf="data.description">
        <span class="sr-only visually-hidden" *ngIf="!showDesc">{{ data.description }}</span>
        <ng-container *ngIf="showDesc">
          <ng-container *ngIf="descTmp; else defaultDescTmp">
            <ng-container *ngTemplateOutlet="descTmp; context: {$implicit: data.description}"></ng-container>
          </ng-container>
          <ng-template #defaultDescTmp>
            <div class="img-desc-wrapper">
              <p class="img-desc">{{data.description}}</p>
            </div>
          </ng-template>
        </ng-container>
      </ng-container>
    </div>
  </div>
  <ol role="tablist" class="carousel-indicators" *ngIf="dotted && bannerMeta && bannerMeta.length > 1">
    <ng-container *ngFor="let data of bannerMeta;let i = index">
      <li role="tab" tabindex="0" [class.active]="i == activeSlideIndex"
      attr.aria-current="{{i == activeSlideIndex}}"
      data-bs-target="#banner_Carousel" [attr.data-bs-slide-to]="i"
      attr.aria-label="{{'viewNSlide' | translate:({n: i+1})}}"
      (keydown.enter)="$event.target.click()"
      ></li>
    </ng-container>
  </ol>
  <a *ngIf="nav && bannerMeta && bannerMeta.length > 1" class="right carousel-control" href="#banner_Carousel" data-bs-slide="next" title="{{'nextImage' | translate}}">
    <span class="fa fa-chevron-right fa-lg" title="{{'nextImage' | translate}}" aria-hidden="true"></span>
    <span class="sr-only visually-hidden">{{'nextImage' | translate}}</span>
  </a>
  <button *ngIf="isTouchScreen && !firstPlayDone" [class.d-none]="!isVideoCurrently || playingVideo" class="btn btn-light manul-play-video-btn" (click)="playCurrentVideo2()"><i class="fa fa-play" aria-hidden="true"></i>
    <span>{{'touchToPlayVideo' | translate}}</span>
  </button>
  <button *ngIf="!hasAllowSound" [class.d-none]="!isVideoCurrently || !playingVideo || !playingVideo.muted" class="btn btn-light open-sound-btn" [class.show-tip]="isShowMuteTip" (click)="cancelVideoMute()"><i class="icon-no-sound" aria-hidden="true"></i>
    <span>{{'unmute' | translate}}</span>
  </button>
</div>
